import { faStar } from "@jewlr/pro-solid-svg-icons/faStar"

import { Text } from "@jewlr/storybook/info"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

const ratingData = [
  {
    percentage: "78%",
    star: 5,
  },
  {
    percentage: "16%",
    star: 4,
  },
  {
    percentage: "4%",
    star: 3,
  },
  {
    percentage: "1%",
    star: 2,
  },
  {
    percentage: "1%",
    star: 1,
  },
]

const ReviewsChart = () => {
  return (
    <div className="tablet:gap-24 tablet:flex-row mb-40 flex flex-col">
      <div className="tablet:mb-0 mb-40 flex-1">
        <div className="bg-grey-4 tablet:py-56 tablet:px-40 tablet:text-left h-full p-32 text-center">
          <h2 className="text-18 tablet:text-22 tablet:mb-32 mb-24 leading-none">
            Hear what our customers
            <span className="nowrap"> are saying.</span>
          </h2>
          <div aria-hidden className="mb-8" role="img">
            {new Array(5).fill(null).map((_, i) => (
              <FontAwesomeIcon
                aria-hidden
                className="text-rating"
                icon={faStar}
                key={`star-${i}`}
              />
            ))}
          </div>
          <Text>50K+ 5-Star Reviews</Text>
        </div>
      </div>
      <div className="flex-1">
        <div className="mb-24 text-center">
          <h3 className="text-18 tablet:text-22 leading-none">
            94% of Reviews
          </h3>
          <Text>are 4 and 5-star-rating</Text>
        </div>
        {ratingData.map((rate, i) => (
          <div
            className="mb-16 flex justify-center gap-16"
            key={`reviewbar${i}`}
          >
            <p className="text-neutral text-14 w-68 font-light">
              {rate.star} star
            </p>
            <div className="bg-grey-4 w-full flex-1">
              <div
                className="w-(--base-width) bg-rating h-20"
                style={{
                  "--base-width": rate.percentage,
                }}
              />
            </div>
            <div className="text-neutral text-14 w-68 font-light">
              {rate.percentage}
            </div>
          </div>
        ))}

        <p className="text-neutral text-10 font-light">From Shopper Approved</p>
      </div>
    </div>
  )
}

export default ReviewsChart
